<template>
  <div>
   
    <v-card-title>
      
      <v-spacer></v-spacer>

      <v-btn class="mx-0" color="info" title="Download" @click="downloadFIle">
        <v-icon color="white">cloud_download</v-icon>
      </v-btn>  

      <!-- <v-btn color="error" @click="previous" title="Back">
          <v-icon>arrow_back_ios</v-icon>Back
        </v-btn> -->

    </v-card-title>

    <table width="100%" class="tblClass">
      <tbody>     
        <tr>
          <th>&nbsp;&nbsp; Project Name</th>
          <td colspan="3" style="font-weight:bold; padding-left:8px;">{{packagesList.project_name}}</td>
        </tr>
        <tr>
          <td colspan="4">&nbsp;</td>
        </tr>

        <tr class="textCenter">          
          <th>Version No.</th>
          <th>Version Date.</th> 
          <th>Package Name</th> 
          <th>Package Number</th> 
        </tr>

        <tr class="textCenter">          
          <td>{{packagesList.package_versions_id}}</td>
          <td>{{(packagesList.versioning_date) ? changeFormateDMY(packagesList.versioning_date) : ''}}</td>
          <td>{{packagesList.name}}</td>
          <td>{{packagesList.package_no}}</td>
        </tr>


        <tr class="textCenter">
          <th>From Date</th> 
          <th>To date</th>
          <th>Procurement Type</th> 
          <th>Unit</th> 
        </tr>
        <tr class="textCenter">
          <td>{{(packagesList.from_date) ? changeFormateDMY(packagesList.from_date) : ''}}</td>
          <td>{{(packagesList.to_date) ? changeFormateDMY(packagesList.to_date) : ''}}</td>
          <td>{{packagesList.pro_type_name}}</td>
          <td>{{packagesList.unit_name}}</td>
        </tr>


        <tr class="textCenter">
          <th>Beneficiary Name</th> 
          <th>Quantity Lot</th>
          <th>Quantity</th> 
          <th>Method</th> 
        </tr>
        <tr class="textCenter">
          <td>{{packagesList.beneficiary_name}}</td>
          <td>{{packagesList.quantity_lot}}</td>
          <td>{{packagesList.quantity}}</td>
          <td>{{packagesList.method_name + ' ( '+ packagesList.market_approach + ' )'}}</td>
        </tr>

        <!-- <tr class="textCenter">
          <th>Estimated Price</th> 
          <th>Actual Cost</th> 
          <th>Es Currency</th>
          <th>Es Currency Rate</th> 
          <th>Estimated bdt</th> 
        </tr>
        <tr class="textCenter">
          <td>{{packagesList.estimated_price}}</td>
          <td>{{(packagesList.actual_cost) ? packagesList.actual_cost : '&nbsp;'}}</td>
          <td>{{packagesList.es_currency}}</td>
          <td>{{packagesList.es_currency_rate}}</td>
          <td>{{packagesList.estimated_bdt}}</td>
        </tr>-->

        <!--<tr class="textCenter">
          <th>Actual Cost</th> 
           <!--<th>Actual Currency</th>
          <th>Actual Currency Rate</th> 
          <th>Actual bdt</th>
        </tr>
       <tr class="textCenter">
          <td>{{(packagesList.actual_cost) ? packagesList.actual_cost : '&nbsp;'}}</td>
          <td>{{packagesList.actual_currency}}</td>
          <td>{{packagesList.ac_currency_rate}}</td>
          <td>{{packagesList.actual_bdt}}</td>
        </tr>-->

        <tr class="textCenter">
          <th>Contract Type</th> 
          <th>Prior Rev</th> 
          <th>Status</th> 
          <th>Remarks</th> 
        </tr>
        <tr class="textCenter">
          <td>{{packagesList.contract_type_name}}</td>
          <td>{{packagesList.prior_rev == 0 ? 'No' : 'Yes'}}</td>
          <td>{{satusName(packagesList.status_id)}}</td>
          <td>{{packagesList.remarks}}</td>
        </tr>

        <tr class="textCenter">
          <th>Estimated Price</th> 
          <th>Actual Cost</th> 
        </tr>
        <tr class="textCenter">
          <td>{{packagesList.estimated_price | currency}}</td>
          <td>{{(packagesList.actual_cost) ? packagesList.actual_cost : '&nbsp;'}}</td>
        </tr>      

      </tbody>
    </table>
    <br><br>

    <table width="100%" class="tblClass">
      <tbody>
        <tr>
          <th colspan="3" style="font-weight:bold; font-size:20px; padding:10px 0px;" class="textCenter">Economic Code</th>
        </tr>
        <tr class="textCenter">
          <th>Eco Code</th>
          <th>Eco Code Name</th>
          <th>Amount</th>
        </tr>
        <tr v-for="item in packagesEcoList" class="textCenter" :key="item">
          <td>{{item.eco_account_code}}</td>
          <td>{{item.eco_code}}</td>
          <td>{{item.amount | currency}}</td>
        <tr>
        </tr>
      </tbody>      
    </table>
    <br><br>


    <table width="100%" class="tblClass">
      <tbody>
        <tr>
          <th colspan="12" style="font-weight:bold; font-size:20px; padding:10px 0px;" class="textCenter">Package Execution Steps</th>
        </tr>
        <tr class="textCenter">
          <th>Step Name</th>
          <th>Tentative Start Date</th>
          <th>Total Days</th>
          <th>Tentative End Date</th>
          <th>Actual Start Date</th>
          <th>Total Days</th>
          <th>Actual End Date</th>
          <th>Complain</th>
          <th>Remarks</th>
          <th>Supplier</th>
          <th>Documents</th>
        </tr>
        <tr v-for="(item,index) in executionList" class="textCenter" :key="index">
          <td>{{item.step_name}}</td>          
          <td>{{(item.start_date) ? changeFormateDMY(item.start_date) : ''}}</td>
          <td>{{item.tentative_total_days}}</td>          
          <td>{{(item.end_date) ? changeFormateDMY(item.end_date) : ''}}</td>
          <td> {{(item.actual_start_date) ? changeFormateDMY(item.actual_start_date) : ''}}</td>
          <td>{{item.total_days}}</td>          
          <td>{{(item.actual_end_date) ? changeFormateDMY(item.actual_end_date) : ''}}</td>
          <td>{{item.complain}}</td>
          <td>{{item.remarks}}</td>
          <td>{{item.supplier_name}}</td>
          <td>
          <span v-for="(item2,index2) in item.document_path">
            <a
                :href="`${public_path}${item2.document}`"
                target="_blank"
                rel="noopener noreferrer"
                download=""
              >
                {{ (index2+1)+ '. ' + item2.document_title }} <br>
                
              </a>
            </span>  
            </td>
        <tr>
        </tr>
      </tbody>      
    </table>

  </div>
</template>


<script>
const commonService = require('../../../services/common.service');
import Axios from "axios";
import ServerPath from '../../../server-path/server-path';

export default {

  data: () => ({
    valid: true,    

     queryData2: {
      packageId: "",
      versionNo:""
    },

    packagesList:[],
    packagesEcoList:[],
    executionList:[],    

  }),

  created() {
    this.public_path = ServerPath.serverPath;
    let query_Data2 = this.queryData2;
        
        (query_Data2.packageId = sessionStorage.getItem("pacId")),
        (query_Data2.versionNo = sessionStorage.getItem("pacVersionId"));          

        commonService.getServerSideData(query_Data2, "package-execution-details")
        .then(res => {
          console.log(res)

          this.packagesList = res.packagesList;
          this.packagesEcoList = res.packagesEcoList;
          this.executionList = res.executionList;
          
        })   
  },

  
  methods: {

    satusName(statusId){
    let status_list = [
      { id: "1", name: "Plan" },
      { id: "2", name: "Execute" },
      { id: "3", name: "Revision" },
      { id: "4", name: "Merge" },
      { id: "5", name: "Split" },
      { id: "6", name: "Close" },
      { id: "7", name: "Cancel" },
      { id: "8", name: "Procured" },
    ];
    if (statusId) {
      return status_list.filter(function(a) {
        return a.id == statusId;
      })[0].name;
      
      //console.log('status_list', status_list)
    }

    },

    downloadFIle(){

      let query_Data2 = this.queryData2;
        
        (query_Data2.packageId = sessionStorage.getItem("pacId")),
        (query_Data2.versionNo = sessionStorage.getItem("pacVersionId"));

      let parameters = new URLSearchParams({ ...query_Data2}).toString();
      let route = ServerPath.serverPath+'/execution-details-pdf?'+parameters;
      window.open(route, '_blank');
    },

    previous(){
      this.$router.push('/procurement/executions') 
    }
  }
};
</script>

<style scoped>
.tblClass{
  border-collapse: collapse;
}
.tblClass tr th,
.tblClass tr td{
  border:1px solid #CCC;
  padding:8px 0px;
}
.textCenter tr th,
.textCenter tr td,
.textCenter{
  text-align: center;  
}
</style>


// WEBPACK FOOTER //
// src/components/procurement/execution/ExecutionVieweDetails.vue